import React, { useEffect } from "react";
import { getUnixTime } from 'date-fns'
import { useSelector } from "react-redux";
import externals from "../../../utils/externals";
import _ from "lodash";
import useCurrentService from "utils/useCurrentService"

const style = window.document.createElement('style');
style.type = 'text/css';
window.document.head.appendChild(style);

const loadIntercom = _.once(() => {
    if (externals.intercomId) {
        (function () {
            var w = window;
            var ic = w.Intercom;
            if (typeof ic === "function") {
                ic('reattach_activator');
                ic('update', window.intercomSettings);
            } else {
                var d = document;
                var i = function () {
                    i.c(arguments)
                };
                i.q = [];
                i.c = function (args) {
                    i.q.push(args)
                };
                w.Intercom = i;

                function l() {
                    var s = d.createElement('script');
                    s.type = 'text/javascript';
                    s.async = true;
                    s.src = 'https://widget.intercom.io/widget/' + externals.intercomId;
                    var x = d.getElementsByTagName('script')[0];
                    setTimeout(function () {
                        x.parentNode.insertBefore(s, x)
                    }, 3000);
                }

                if(w.__loaded) {
                    l()
                } else {
                    if (w.attachEvent) {w.attachEvent('onload', l);} else {w.addEventListener('load', l, false);}
                }
            }
        })()
    } else {
        window.Intercom = () => {};
    }
});

const hide = () => {
    style.innerHTML = `.intercom-container, .intercom-lightweight-app, .intercom-app {
        display: none !important;
    }`;
};

const show = () => {
    style.innerHTML = ``;
};

export default React.memo(() => {
    const { email, userId, status, isAuthenticated } = useSelector(state => state.auth);
    const appState = useSelector(state => state.app.appState);
    const accountSerial = useSelector(state => state.tenancy.selectedAccount?.accountSerial)
    const about = useSelector(state => state.currentConnector.about)
    const instancePlacement = useSelector(state => state.currentConnector.instancePlacement)
    const currentService = useCurrentService();
    const hideIntercom = _.get(currentService, "service.hideIntercom", false);

    useEffect(() => {
        if (appState !== "loading") {
            loadIntercom();
        }
    }, [appState]);

    useEffect(() => {
        if (hideIntercom) {
            hide();
        } else {
            show();
        }
    }, [hideIntercom]);

    useEffect(() => {
        if ((status !== "PENDING" && status !== "UNSET") || appState === "proxy") {
            if (isAuthenticated) {
                window.Intercom('boot', {
                    app_id: externals.intercomId,
                    email: email,
                    user_id: userId,
                    created_at: getUnixTime(new Date()), //Returns Unix timestamp (in seconds)
                });
            } else {
                window.Intercom('boot', {
                    app_id: externals.intercomId
                });
            }
        }
    }, [email, userId, status, isAuthenticated, appState]);

    useEffect(() => {
        if (about && instancePlacement) {
            window.Intercom('update', {
                "build": about.build,
                "beta": about.beta,
                "build_time": about.buildTimestamp,
                "version": about.version,
                "site": about.siteIdentifier?.site,
                "system_id": about.systemId,
                "install_location": instancePlacement?.installLocation
            })
        }
    }, [about, instancePlacement])

    useEffect(() => {
        if (accountSerial) {
            window.Intercom('update', {
                "Account Serial": accountSerial
            })
        }
    }, [accountSerial])

    return "";
});
